<template>
  <div class="list">
    <div class="list-item sep">
      <img
        class="icon"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/name.png"
      />
      <input
        v-model="cusName"
        type="text"
        placeholder="请输入姓名"
        class="flex1 stretch"
      />
    </div>
    <div class="list-item sep">
      <img
        class="icon"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/sex.png"
      />
      <radio v-model="cusSex" :data="radioData">
        <span slot="title">请选择性别</span>
      </radio>
    </div>
    <div class="list-item sep">
      <img
        class="icon"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/tel.png"
      />
      <input
        v-model="cusTel"
        placeholder="请输入手机号"
        type="tel"
        class="flex1 stretch"
      />
    </div>
    <div class="list-item more sep">
      <img
        class="icon"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/property.png"
      />
      <span
        @click.stop="handleChooseBuilding"
        class="flex1 text-vcenter ellipsis"
        :class="{ gray: selectBuildings.length === 0 }"
        >{{ this.building || "请选择推荐楼盘" }}</span
      >
    </div>
    <div v-if="showConsult" class="list-item more sep">
      <img
        class="icon"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/personnel.png"
      />
      <span
        @click.stop="handleChooseConsultant"
        class="flex1 text-vcenter ellipsis"
        :class="{ gray: !selectAdvisor }"
        >{{ advisorName }}</span
      >
    </div>
    <div class="list-item sep">
      <img
        class="icon"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/remark.png"
      />
      <input
        v-model="remark"
        placeholder="如有其他补充说明，请在此备注"
        class="flex1 stretch"
      />
    </div>
    <div class="rules" v-if="rules.length > 0">
      <span>《客户报备规则条款》</span>
      <span>{{ curBuildingName }}</span>
      <div class="switch">
        <img
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/left-circle-arrow.png"
          @click.stop="handleRuleSwitch(false)"
        />
        <span>{{ `${idx + 1}/${selectBuildings.length}` }}</span>
        <img
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/right-circle-arrow.png"
          @click.stop="handleRuleSwitch(true)"
        />
      </div>
      <span v-html="rules[idx].textFile" />
    </div>

    <div class="scrim" v-if="showProtocol">
      <div class="protocol-layer">      
        <div class="protocols" v-if="protocols.length > 0">
          <span>《阳光宣言规则条款》</span>
          <span>{{ protocols[pdx].housesD }}</span>
          <div class="switch">
            <img
              src="https://assets.rurushishi.com/yq-rs-make/huafa/img/left-circle-arrow.png"
              @click.stop="handleProtocolSwitch(false)"
            />
            <span>{{ `${pdx + 1}/${protocols.length}` }}</span>
            <img
              src="https://assets.rurushishi.com/yq-rs-make/huafa/img/right-circle-arrow.png"
              @click.stop="handleProtocolSwitch(true)"
            />
          </div>
          <span v-html="protocols[pdx].textFile" />
        </div>
        <div class="close" @click="showProtocol = false"></div>
      </div>
    </div>

    <div class="list-item protocol-wrap" v-if="protocols.length > 0">
      <img
        v-if="protocol"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/selected.png"
        class="icon"
        @click="protocol = false"
      />
      <img
        v-else
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/select-default.png"
        class="icon"
        @click="protocol = true"
      />
      <label class="flex1 protocol" for="clause">
        <span>我已阅读并同意</span>
        <span class="text-warning" @click="handleReadAgreement"
          >《阳光宣言规则条款》</span
        >
      </label>
    </div>

    <div
      class="submit-btn"
      style="margin-top: 0.32rem;"
      @click.stop="handleSubmit"
    >
      提交
    </div>
    <div class="tabbar-height" />
    <tabbar7 />
  </div>
</template>

<script>
import Radio from "../components/radio";
import { createNamespacedHelpers } from "vuex";
import { Toast } from "mint-ui";
import {
  buildingCanRecommend,
  getRulesOfBuilding,
  getNewestRuleList,
  saveClientInfo
} from "./api";

import { getRecomBuildings } from "../choose-building/api";
import Cookies from "js-cookie";

const Tabbar7 = () => import("@/components/tabbar7");

import { getAgent } from "../api";
const { mapState, mapMutations } = createNamespacedHelpers("qmyx");

export default {
  components: {
    Radio,
    Tabbar7
  },
  data() {
    return {
      cusSex: "男",
      radioData: [
        { name: "男", value: "10" },
        { name: "女", value: "20" }
      ],
      cusName: "",
      cusTel: "",
      building: null,
      remark: "",
      hasPermission: true,
      rules: [],
      idx: 0,
      agentInfo: {},

      showProtocol: false,
      pdx: 0,
      protocols: [],
      protocol: false, // 是否同意阳光协议
    };
  },
  computed: {
    ...mapState(["selectBuildings", "selectAdvisor", "backupInfo"]),
    showConsult() {
      return this.selectBuildings.length == 1 && this.hasPermission;
    },
    advisorName() {
      return (this.selectAdvisor || {}).salesName || "请选择接待置业顾问";
    },
    curBuildingName() {
      if (this.selectBuildings.length > 0) {
        return (this.selectBuildings[this.idx] || {}).housesD || "";
      }
      return "";
    }
  },
  watch: {
    selectBuildings: {
      immediate: true,
      deep: true,
      handler(val) {
        this.building = (val || []).map(i => i.housesD).join("，");

        if (val && val.length === 1) {
          this.canRecommendBuilding(val[0]);
        }
        if (val && val.length > 0) {
          this.handleLoadRules(val);
        } else {
          this.rules = [];
        }
      }
    }
  },
  activated() {
    console.log("route.params:::::", this.$router);
    Object.keys(this.backupInfo).every(key => {
      this[key] = this.backupInfo[key];
      return true;
    });
    this.loadAgent();
  },
  beforeRouteEnter(to, from, next) {
    console.log("测试====？", from);
    if (
      from.name !== "choose-building" &&
      from.name !== "advisor-select" &&
      from.name !== "my-customer"
    ) {
      next(vm => {
        vm.reset();
        vm.initSelectBuildingsIfNeed();
      });
    } else {
      next();
    }
  },
  destroyed() {
    console.log("client-backup销毁掉了");
  },
  methods: {
    ...mapMutations([
      "saveBackupInfo",
      "saveSelectAdvisor",
      "reset",
      "saveSelectBuildings"
    ]),
    async loadAgent() {
      try {
        const agentInfo = await getAgent();
        this.agentInfo = agentInfo;
      } catch (e) {
        // const { response: { status, data = "网络异常" } = {} } = e || {};
        this.$router.replace({ name: "agent-auth" });
      }
    },
    async initSelectBuildingsIfNeed() {
      // 处理从楼盘详情 推荐过来的 会把projectId带过来 需要默认选中这个楼盘
      const query = window.location.href.split("?")[1];
      let params = undefined;
      if (query) {
        const keyvals = query.split("&") || [];
        params = keyvals.reduce((obj, cur) => {
          const arrs = cur.split("=");
          if (arrs && arrs.length === 2) {
            const key = decodeURIComponent(arrs[0]).toLowerCase();
            const val = decodeURIComponent(arrs[1]);
            obj[key] = val;
          }
          return obj;
        }, {});
      }
      if (params && params.projectid) {
        const cityName = Cookies.get("hf_cur_city_name") || "珠海";
        const resp = await getRecomBuildings(cityName);
        const { resuleInfo = [] } = resp;
        const filters = resuleInfo.filter(
          i => i.projectId === params.projectid
        );
        if (filters && filters.length > 0) {
          this.saveSelectBuildings(filters);
        }
      }
    },
    handleSaveBackupInfo() {
      const keys = ["cusName", "cusSex", "cusTel", "remark"];
      const info = keys.reduce((obj, key) => {
        obj[key] = this[key];
        return obj;
      }, {});
      this.saveBackupInfo(info);
    },
    handleChooseBuilding() {
      this.handleSaveBackupInfo();
      this.$router.push({
        name: "choose-building",
        params: this.$route.params
      });
    },
    handleChooseConsultant() {
      this.handleSaveBackupInfo();
      this.$router.push({
        name: "advisor-select",
        params: {
          id: this.selectBuildings[0].housesUuid
        }
      });
    },
    async handleLoadRules(buildings) {
      if (!this.agentInfo || !this.agentInfo.status) {
        await this.loadAgent();
      }
      console.log("this.agentInfo", this.agentInfo);
      const results = [];
      let housesUuids = []
      for (const b of buildings) {
        housesUuids.push(b.housesUuid)
        const tmp = await getRulesOfBuilding(
          b.housesUuid,
          this.agentInfo.status
        );
        results.push(tmp);
      }
      this.rules = results;
      this.idx = 0;
      let protocols = await getNewestRuleList(
        housesUuids.join(','),
        30
      );
      this.protocols = protocols.data.filter(e => {
        return e && e.id
      })
      this.pdx = 0
      console.log('=======>',this.protocols)
      if(this.protocols.length <= 0) {
        this.protocol = true
      }
    },
    handleReadAgreement() {
      this.protocol = true
      this.showProtocol = true
    },
    handleRuleSwitch(isNext) {
      let tmp = isNext ? this.idx + 1 : this.idx - 1;
      if (tmp >= this.rules.length) {
        tmp = 0;
      } else if (tmp < 0) {
        tmp = this.rules.length - 1;
      }
      this.idx = tmp;
    },
    handleProtocolSwitch(isNext) {
      let tmp = isNext ? this.pdx + 1 : this.pdx - 1;
      if (tmp >= this.protocols.length) {
        tmp = 0;
      } else if (tmp < 0) {
        tmp = this.protocols.length - 1;
      }
      this.pdx = tmp;      
    },
    async canRecommendBuilding(building) {
      const resp = await buildingCanRecommend(building.housesUuid);
      console.log("楼盘是否能推荐：", resp);
      this.hasPermission =
        resp &&
        resp.result &&
        (resp.result.disFlag === "X" || resp.result.operateFlag === "X");
    },
    async handleSubmit() {
      if (this.handleValidate()) {
        const { agentLogin: { agentName = "" } = {} } = this.agentInfo;
        const params = {
          cusName: this.cusName,
          cusSex: this.cusSex,
          cusTel: this.cusTel,
          housesId: this.selectBuildings.map(i => i.housesUuid).join(","),
          remark: this.remark || "",
          reportAgentName: agentName
        };
        console.log(params);
        if (this.showConsult && this.selectAdvisor) {
          params.saleAdvister = this.selectAdvisor.salesId;
        }
        const { data } = await saveClientInfo(params);
        this.$router.push({
          name: "backup-result",
          params: { results: data || [] }
        });
      }
    },
    handleValidate() {
      if (!this.cusName) {
        Toast("请输入姓名");
        return false;
      }
      if (this.cusName.length > 20) {
        Toast("姓名不能超过20字!");
        return false;
      }
      if (!/^[a-zA-Z\u4e00-\u9fa5]+$/.test(this.cusName)) {
        Toast("姓名不能包含特殊字符!");
        return false;
      }
      if (!this.cusTel || !/^1[3456789]\d{9}$/.test(this.cusTel)) {
        Toast("请输入正确的手机号码");
        return false;
      }
      if (!this.selectBuildings || this.selectBuildings.length === 0) {
        Toast("请先选择推荐楼盘");
        return false;
      }
      if (!this.protocol) {
        Toast("请同意《阳光宣言规则条款》");
        return false;
      }
      // if (this.showConsult && !this.selectAdvisor) {
      //   Toast("请选择置业顾问");
      //   return false;
      // }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.gray {
  color: #bbbbbb;
}

.scrim {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 10;
  background: rgba(0,0,0,0.7);
  .protocol-layer {
    position: absolute;
    left: .6rem;
    right: .6rem;  
    top: 15%;  
    .close {
      width: 0.88rem;
      height: 0.88rem;
      margin: 0 auto;
      margin-top: .5rem;
      background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/close2.png') no-repeat center center;
      background-size: 0.64rem 0.64rem;
    }  
    .protocols {
      background: #ffffff;
      padding: .2rem;
      border-radius: 10px;
      height: 9rem;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      & > span:nth-of-type(1) {
        font-size: 0.3rem;
        font-weight: 500;
        color: #222222;
      }
      & > span:nth-of-type(2) {
        font-size: 0.28rem;
        font-weight: 500;
        color: #222222;
        display: block;
        margin: 0.24rem 0;
      }
      & > span:last-of-type {
        margin-top: 0.4rem;
        font-size: 0.26rem;
        color: #101010;
        line-height: 0.44rem;
        vertical-align: middle;
      }
      .switch {
        position: absolute;
        display: block;
        top: 0.32rem;
        right: 0.36rem;
        display: flex;
        align-items: center;
        & > span {
          font-size: 0.26rem;
          color: #222222;
          margin: 0 0.16rem;
        }
        & > img {
          width: 0.4rem;
          height: 0.4rem;
        }
      }    
    }
  }
}

.rules {
  position: relative;
  padding: 0.36rem 0.36rem;
  background: #f5f5f5;
  margin-top: 0.6rem;
  margin-bottom: 0.32rem;
  & > span:nth-of-type(1) {
    font-size: 0.3rem;
    font-weight: 500;
    color: #222222;
  }
  & > span:nth-of-type(2) {
    font-size: 0.28rem;
    font-weight: 500;
    color: #222222;
    display: block;
    margin: 0.24rem 0;
  }
  & > span:last-of-type {
    margin-top: 0.4rem;
    font-size: 0.26rem;
    color: #101010;
    line-height: 0.44rem;
    vertical-align: middle;
  }
  .switch {
    position: absolute;
    display: block;
    top: 0.32rem;
    right: 0.36rem;
    display: flex;
    align-items: center;
    & > span {
      font-size: 0.26rem;
      color: #222222;
      margin: 0 0.16rem;
    }
    & > img {
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}
</style>
